import React from "react";
import { ScrapeJobsRow } from "./ScrapeJobsRow";

export const ScrapeJobsTable = ({ jobs, loading, onDelete, onEdit, deleteLoading, onLoadMore, pagination }) => (
  <div className="mt-4 rounded-3xl bg-jp-card border border-jp-line overflow-hidden">
    {/* Scrollable Table Container */}
    <div className="overflow-auto" style={{ maxHeight: '500px' }}>
      <table className="min-w-full text-[11px] border-collapse">
        <thead className="bg-jp-card text-jp-ink sticky top-0 z-10">
          <tr className="border-b border-jp-line">
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">JOB NAME</th>
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">PLAYER NAME</th>
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">TEAM</th>
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">POSITION</th>
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">SCHEDULE</th>
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">LAST RUN</th>
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">STATUS</th>
            <th className="px-4 py-3 text-left bg-jp-card border-b border-jp-line">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          {loading && jobs.length === 0 ? (
            <tr>
              <td colSpan="8" className="px-4 py-8 text-center text-jp-muted">
                Loading scrape jobs...
              </td>
            </tr>
          ) : jobs.length === 0 ? (
            <tr>
              <td colSpan="8" className="px-4 py-8 text-center text-jp-muted">
                No scrape jobs found
              </td>
            </tr>
          ) : (
            <>
              {jobs.map((job) => (
                <ScrapeJobsRow
                  key={job._id}
                  job={job}
                  onDelete={onDelete}
                  onEdit={onEdit}
                  deleteLoading={deleteLoading[job._id]}
                />
              ))}
              {/* Load More Row */}
              {pagination?.hasMore && (
                <tr>
                  <td colSpan="8" className="px-4 py-4 text-center">
                    <button
                      onClick={onLoadMore}
                      disabled={loading}
                      className="px-6 py-2 rounded-lg bg-sky-500 text-white text-xs font-semibold hover:bg-sky-400 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                      {loading ? "Loading..." : "Load More"}
                    </button>
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>

    {/* Fixed Footer - Showing results info */}
    {pagination && jobs.length > 0 && (
      <div className="px-6 py-3 border-t border-jp-line bg-jp-card">
        <div className="text-xs text-jp-muted text-center">
          Showing {jobs.length} of {pagination.totalCount} results
        </div>
      </div>
    )}
  </div>
);
